import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import {
  VolumeInput,
  checkNumeric,
  formatNumber,
  randomFrom,
  randInt,
  renderFractionUserAnswer,
} from "./PyramidVolumeCommon";

export function generateTask() {
  const legA = randomFrom([6, 8, 10, 12, 14]);
  const legB = randomFrom([6, 9, 12, 15, 18]);
  const h = 2 * randInt(3, 9);
  const baseArea = (legA * legB) / 2;
  const volume = (baseArea * h) / 3;
  return {
    type: "RightTriangleBasePyramidVolumeTask",
    data: { legA, legB, h, baseArea, volume },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>Podstawą ostrosłupa jest trójkąt prostokątny o przyprostokątnych:</p>
      <BlockMath
        math={`${data.legA}\\,\\text{cm}\\quad \\text{i}\\quad ${data.legB}\\,\\text{cm}`}
      />
      <p>
        Wysokość ostrosłupa jest równa{" "}
        <InlineMath math={`${data.h}\\,\\text{cm}`} />. Oblicz objętość tego ostrosłupa.
      </p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <VolumeInput value={userAnswer} onChange={onChange} disabled={disabled} />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkNumeric(userAnswer, data.volume);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`V=${formatNumber(data.volume)}\\,\\text{cm}^3`} />;
}

export function renderUserAnswer(userAnswer) {
  return renderFractionUserAnswer(userAnswer, "V", String.raw`\text{cm}^3`);
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> Liczymy pole podstawy. Podstawa jest trójkątem prostokątnym.
      </p>
      <BlockMath
        math={`P_p=\\frac{${data.legA}\\cdot ${data.legB}}{2}=${formatNumber(
          data.baseArea
        )}\\,\\text{cm}^2`}
      />
      <p>
        <strong>Krok 2:</strong> Podstawiamy pole podstawy i wysokość do wzoru na objętość.
      </p>
      <BlockMath
        math={`V=\\frac{1}{3}P_p\\cdot H=\\frac{1}{3}\\cdot ${formatNumber(
          data.baseArea
        )}\\cdot ${data.h}=${formatNumber(data.volume)}\\,\\text{cm}^3`}
      />
    </div>
  );
}
